export default "__VITE_ASSET__wgZ91eHF__"